import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import AdminPageEvent from "../../components/web/layoutsadmin/AdminPageEvent";
import {MdKeyboardArrowDown} from "react-icons/md";
import maCateImg from "../../assets/img/m-a-cate.png";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";

function AdminFAQPg() {

    /** region DataTable */

    const [data, setData] = useState([]);

    /** endregion */

    /** region Function */

    const navigate = useNavigate();

    const moveToDetailPg = ((seqNum) => {
        navigate(`/btcorpad/adminfaq-detail/${seqNum}`)
    })

    //region ScrollPagination

    const [displayLimit, setDisplayLimit] = useState(10);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [data.length, displayLimit]);

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) return;
        if (data.length > displayLimit && displayLimit < 30) {
            setDisplayLimit(prevLimit => prevLimit + perPg);
        }
    };

    const loadMoreData = () => {
        setDisplayLimit(prevLimit => prevLimit + perPg);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(10);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const handleSelectChange = (e) => {
        const newPerPage = parseInt(e.target.value);
        setperPg(newPerPage);
        setCurrentPage(1);
    };

    useEffect(() => {
        setDisplayLimit(perPg);
    }, [perPg]);

    const [checkItems, setCheckItems] = useState([]);
    useEffect(() => {}, [checkItems]);
    const handleSingleCheck = (checked, seqNum) => {
        if (checked) {
            setCheckItems(prev => [...prev, seqNum]);
        } else {
            setCheckItems(checkItems.filter((el) => el !== seqNum));
        }
    };
    const handleAllCheck = (checked) => {
        if(checked) {
            const idArray = [];
            data.forEach((el) => idArray.push(el.seqNum));
            setCheckItems(idArray);
        } else {
            setCheckItems([]);
        }
    }

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const startHandle = (e) => {setStartDate(e.target.value);};
    const endHandle = (e) => {setEndDate(e.target.value);};

    useEffect(() => {
        const today = new Date();
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        const formatDateString = (date) => {
            // return date.toISOString().split('T')[0];
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        setStartDate(formatDateString(oneMonthAgo));
        setEndDate(formatDateString(today));
    }, []);

    const selectAllFaqBetDates = (()=> {
        const formattedStartDate = startDate.replace(/-/g, '');
        const formattedEndDate = endDate.replace(/-/g, '');
        axios({
            method: 'get',
            url: '/faq/selectAllFaqBetDates/',
            params: {
                startDate: formattedStartDate,
                endDate: formattedEndDate
            }
        })
            .then((response) => {
                let data = response.data.sort((a, b) => b.seqnum - a.seqnum);
                setData(data);
            })
    })

    useEffect(() => {
        if (startDate && endDate)
            selectAllFaqBetDates();
    }, [startDate, endDate])


    const convertToLang = ((lang) => {
        if (lang === "0") return "Korean"
        if (lang === "1") return "English"
        if (lang === "2") return "Japanese"
        if (lang === "3") return "Chinese"
        if (lang === "4") return "Indonesian"
    })

    /** endregion */

    return (
        <div className="AdminFaqPg">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">FAQ</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <div className="admin-event-wrap">
                        <div className="admin-event-wrap-btn">
                            <AdminPageEvent perPg={perPg} handleSelectChange={handleSelectChange}/>
                            <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle} endHandle={endHandle}/>
                        </div>
                        <div className="admin-event-wrap-btn">
                            <button onClick={()=> navigate("/btcorpad/adminfaq-write")} className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">등록</button>
                        </div>
                    </div>
                    <div className="div-tb m-b-10">
                        <div className="div-tb-head ht-60">
                            <div style={{width: "30px"}}>
                                <input className="admin-input-chkBox m-0-a" type='checkbox'
                                       onChange={(e) => handleAllCheck(e.target.checked)}
                                       checked={checkItems.length === data.length}/>
                            </div>
                            <div style={{width: "30px"}}><p>번호</p></div>
                            <div style={{width: "40px"}}><p>언어</p></div>
                            <div style={{width: "150px"}}><p>구분</p></div>
                            <div style={{width: "260px"}}><p>제목</p></div>
                            <div style={{width: "90px"}}><p>작성자</p></div>
                            <div style={{width: "150px"}}><p>등록일시</p></div>
                            <div style={{width: "90px"}}><p>수정자</p></div>
                            <div style={{width: "150px"}}><p>수정일시</p></div>
                        </div>
                        {
                            data
                                .slice(0, displayLimit) // 원본 유지
                                .sort((a, b) => (b.fixFl === true) - (a.fixFl === true)) // 고정 먼저
                                .map((row, i) => {
                                    // 고정 제외 개수로 일반 번호 조정
                                    const fixedCount = data.filter(d => d.fixFl).length;
                                    const number = row.fixFl ? (
                                        <p className="font-b" style={{color: "#FFAF34"}}>고정</p>
                                    ) : (
                                        <p>{i + 1 - fixedCount}</p>
                                    );
                                    return (
                                        <div key={row.seqNum} className="div-tb-body ht-70">
                                            <div style={{width: "30px"}}>
                                                <input
                                                    className="admin-input-chkBox m-0-a"
                                                    type="checkbox"
                                                    name={row.fixFl ? row.seqNum : `select-${row.seqNum}`}
                                                    checked={checkItems.includes(row.seqNum)}
                                                    onChange={e => handleSingleCheck(e.target.checked, row.seqNum)}
                                                />
                                            </div>
                                            <div style={{width: "30px"}}>
                                                {number}
                                            </div>
                                            <div style={{width: "40px"}}><p>{convertToLang(row?.faqMstDTO?.lang)}</p></div>
                                            <div style={{width: "150px"}}><p>{row?.faqMstDTO?.title}</p></div>
                                            <div
                                                style={{width: "260px", cursor: "pointer"}}
                                                onClick={() => moveToDetailPg(row.seqNum)}
                                            >
                                                <p className="NoticeAndFaqText" style={{cursor: "pointer", maxWidth: "300px"}}>
                                                    {row?.title}
                                                </p>
                                            </div>
                                            <div style={{width: "90px"}}><p>{row?.regNm}</p></div>
                                            <div style={{width: "150px"}}><p>{row?.regTime}</p></div>
                                            <div style={{width: "90px"}}><p>{row?.modiNm}</p></div>
                                            <div style={{width: "150px"}}><p>{row?.modiTile}</p></div>
                                        </div>
                                    );
                                })
                        }
                    </div>
                    {displayLimit >= 30 && data.length > displayLimit && (
                        <div className="text-center m-t-20">
                            <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AdminFAQPg
